import React from "react";
import "./Button.css";
import PropTypes from "prop-types";

// `form` only picks the element. It must not reach the DOM, where `form`
// is a string attribute. Everything else (including a caller's className,
// which still replaces "button" as before) is passed through unchanged.
export default function Button({ form, children, ...props }) {
  if (form) {
    return (
      <button className="button" {...props}>
        {children}
      </button>
    );
  }

  return (
    <a className="button" {...props}>
      {children}
    </a>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  form: PropTypes.bool,
};
